import moduleConfig from './module-config';
import netsWrapperLayout from './nets-wrapper';

export default angular
  .module('app.wrapper', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsWrapperLayout', netsWrapperLayout);
